<template>
  <div>
    <b-card>
<!--      <BaseTable-->
<!--        :fields="fields"-->
<!--        :items="items"-->
<!--        :loading="loading"-->
<!--        :rows="pagination.total"-->
<!--        :perPage="filter.size"-->
<!--        :currentPage="filter.page"-->
<!--        :handle-page-change="handlePageChange"-->
<!--      />-->
      <b-table :current-page="0" :busy="loading" :per-page="filter.size" :fields="fields" :items="items" :responsive="true">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #cell(action)="data">
          <div class="options-table">
            <b-overlay :show="data.item.isLoading" spinner-small spinner-variant="primary">
              <b-button @click="ViewApproval(data)" :disabled="data.item.isLoading" variant="outline-primary" size="sm" class="mr-1">View</b-button>
            </b-overlay>
            <b-overlay v-if="data.item.status === 'WAITING APPROVE'" :show="data.item.isLoading" spinner-small spinner-variant="primary">
              <b-button @click="ApproveQuestion(data)" :disabled="data.item.isLoading" variant="outline-primary" size="sm" class="mr-1">Approve</b-button>
            </b-overlay>
            <b-overlay v-if="data.item.status === 'WAITING APPROVE'" :show="data.item.isLoading" spinner-small spinner-variant="primary">
              <b-button @click="RejectQuestion(data)" :disabled="data.item.isLoading" variant="outline-primary" size="sm" class="mr-1">Reject</b-button>
            </b-overlay>
          </div>
        </template>
      </b-table>
      <div class="mt-2">
        <b-pagination v-model="filter.page" :total-rows="pagination.total" :per-page="filter.size">
        </b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput,BTable,BPagination,BSpinner,BOverlay } from "bootstrap-vue";
import { GetManualSalaryService } from '../../services/master_manual_salary.service';
import { successNotification, errorNotification } from "@/auth/utils";
export default {
  name: "ApprovalReleaseSalary",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BaseTable,
    BTable,
    BPagination,
    BSpinner,
    BOverlay
  },
  directives: {
    Ripple,
  },
  watch: {
    'filter.page': function () {
      this.GetReleaseSalary();
    }
  },
  data() {
    return {
      pageTitle: "Approval Release Gaji",
      fields: [
        {
          key: "period",
          label: "Periode"
        },
        {
          key: "countAttendance",
          label: "Hitung Absensi"
        },
        {
          key: "countOvertime",
          label: "Hitung Lembur"
        },
        {
          key: "countSalary",
          label: "Hitung Gaji"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "action",
          class: 'text-center',
          label: "Aksi"
        }
      ],
      items: [],
      loading: false,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
      editId: null,
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    DecodeStatus(status) {
      if (status) {
        return 'Selesai';
      }
      if (!status) {
        return 'Progress';
      }
    },
    ViewApproval(data) {
      return this.$router.push(`/approval-payroll/view/${data.item.payslipId}`);
    },
    RejectQuestion(data) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin Menolak data ini?",
        icon: "info",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.Rejected(data);
        }
      });
    },
    async Rejected(data) {
      window.console.log(data);
      data.item.isLoading = true;
      let req = {
        payslipId: data.item.payslipId,
        status: "REJECT"
      };
      await this.$http.put(`/payslip/update-status/${data.item.payslipId}`, req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this, "Success", result.data.message);
            this.GetReleaseSalary();
          } else {
            errorNotification(this, "Oops!",result.data.message);
          }
          data.item.isLoading = false;
        })
        .catch((e) => {
          data.item.isLoading = false;
          return errorNotification(this, "Oops!", e.message);
        });
    },
    ApproveQuestion(data) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin Menyetujui data ini?",
        icon: "info",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
         if (result.value) {
           this.Approve(data);
         }
      });
    },
    async Approve(data) {
      window.console.log(data);
      data.item.isLoading = true;
      let req = {
        payslipId: data.item.payslipId,
        status: "APPROVE"
      };
      await this.$http.put(`/payslip/update-status/${data.item.payslipId}`, req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this, "Success", result.data.message);
            this.GetReleaseSalary();
          } else {
            errorNotification(this, "Oops!",result.data.message);
          }
          data.item.isLoading = false;
        })
        .catch((e) => {
          data.item.isLoading = false;
          return errorNotification(this, "Oops!",e.message);
        });
    },
    async GetReleaseSalary() {
      this.loading = true;
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        isUpload: false
      };
      this.items   =   [];
      await GetManualSalaryService.find(req)
        .then((result) => {
          if (result.code === "00") {
            window.console.log(result);
            result.data.content.forEach((items) => {
               items['isLoading'] = false;
               items['countAttendance'] = this.DecodeStatus(items.progressCalculateAttendance);
               items['countOvertime'] = this.DecodeStatus(items.progressCalculateOvertime);
               items['countSalary'] = this.DecodeStatus(items.progressCalculatePayroll);
               items['action'] = {...items};
               this.items.push(items);
            });
            this.pagination.total = result.data.total;
          }
          this.loading  =  false;
        })
        .catch((e) => {
          this.loading = false;
          errorNotification(this, "Oops!", e.message);
        });
    }
  },
  mounted() {
    this.GetReleaseSalary();
  }
}
</script>
